import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AuthDialog from "@/components/AuthDialog";
import Home from "@/pages/Home";
import Invite from "@/pages/Invite";
import Me from "@/pages/Me";
import Admin from "@/pages/Admin";
import CardGuide from "@/pages/CardGuide";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollTop />
        <div className="min-h-screen bg-[#070709] text-[#F8F9FA]">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/invite" element={<Invite />} />
            <Route path="/me" element={<Me />} />
            <Route path="/hy-admin-x7k2" element={<Admin />} />
            <Route path="/card-guide" element={<CardGuide />} />
          </Routes>
          <Footer />
          <AuthDialog />
        </div>
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
